import { useAuth } from "@airborne/react-admin";
import { Box, ButtonGroup, IconButton, makeStyles, Theme, Tooltip, useMediaQuery, Zoom } from "@material-ui/core";
import { Cancel, Create, Info } from "@material-ui/icons";
import * as React from "react";
import { Fragment } from "react";
import {
  BooleanField,
  Datagrid,
  FunctionField,
  ListContextProvider,
  TextField,
  useListContext,
  useNotify,
  useRefresh,
} from "react-admin";
import { ConfirmButton } from "../../../../Components/ConfirmButton";
import { CustomDateField } from "../../../../Components/CustomDateField";
import { DetailButton } from "../../../../Components/DetailButton";
import { useAppDataProvider } from "../../../../dataprovider";
import { PbhRequestStatus } from "../../../../Enums/PbhRequestStatus";
import { GetServiceableStatus } from "../../../../Enums/ServiceableStatus";
import RequestRemark from "../../../RequestOrder/Components/PbhRequestOrderList/Notes/RequestRemark";
import RequirementCategoryToolTip from "../RequirementCategoryToolTip";
import { connect } from "react-redux";
import { PBH_DASHBOARD_MODEL_CHANGED } from "../../../../../src/Redux/actions";
import { GetUnserviceableStatus } from "../../../../../src/Enums/UnserviceableStatus";
import { RefNoField } from "./RefNoField";
import { HtmlTooltip } from "./HtmlTooltip";
import RequirementCategory from "../../../../../src/Enums/RequirementCategory";
import { GetAlternatePnStatus } from "../../../../../src/Enums/AlternatePnStatus";
import CopyableTableWrapper from "../../../../../src/Components/CopyableTableWrapper";

const useStyles = makeStyles({
  datagrid: {
    "& .MuiTableCell-body": {
      color: "unset !important",
    },
  },
});

const PbhDashboardDataGrid: any = props => {
  const classes = useStyles();
  const listContext = useListContext();
  const dataProvider = useAppDataProvider();
  const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down("xs"));
  const [isMatchCreate, setIsMatchCreate] = React.useState(false);
  const [request, setRequest] = React.useState<any>({});
  const { user } = useAuth();
  const notify = useNotify();
  const refresh = useRefresh();

  const DetailButtons = props => {
    return <DetailButton {...props} resource="pbhrequestorders" />;
  };
  const RemarkButton = props => {
    return (
      <IconButton style={{ width: 40 }} onClick={remarkOnClick(props.record)}>
        <Tooltip TransitionComponent={Zoom} title="Add Note">
          <Create />
        </Tooltip>
      </IconButton>
    );
  };

  const CancelButton = props => {
    return (
      <ConfirmButton
        {...props}
        variant="text"
        style={{ width: 40, color: props?.disabled ? "" : "#C90C0F" }}
        size="medium"
        click={cancelOnClick(props?.record)}
        disabled={props.disabled}
      >
        <Tooltip TransitionComponent={Zoom} title="Cancel Request">
          <Cancel />
        </Tooltip>
      </ConfirmButton>
    );
  };

  const cancelOnClick = record => e => {
    dataProvider
      .getOne("pbhrequestorders/", { id: record.id })
      .then(response => {
        response.data.requestStatus = PbhRequestStatus.Cancelled;
        dataProvider
          .updatePbhRequestOrder(response.data)
          .then(result => {
            notify(`Record Updated`, "success", false, true);
          })
          .catch(error => notify(`${error}`, "error", false, true));
      })
      .finally(() => refresh());
  };

  const remarkOnClick = props => e => {
    e.stopPropagation();
    setRequest(props);
    setIsMatchCreate(true);
  };

  const cancelButtonIsVisible = record => {
    if (record?.requestStatus === PbhRequestStatus.RejectedDueToPoolScope) return false;

    if (user?.isCustomer === true) {
      return record?.requestStatus === PbhRequestStatus.Open ? true : false;
    } else {
      return record?.requestStatus === PbhRequestStatus.Accomplished ? false : true;
    }
  };
  const getSvcStatus = (record: any) => {
    if (record?.requestStatus === PbhRequestStatus.RejectedDueToPoolScope) {
      return "-";
    }
    return record.serviceable
      ? (GetServiceableStatus.find(x => x.Value == record.serviceable)?.Description ?? "UNKNOWN")
      : "NOT SHIPPED YET";
  };
  const getUnsvcStatus = (record: any) => {
    if (record?.requestStatus === PbhRequestStatus.RejectedDueToPoolScope) {
      return "-";
    }
    return record.unserviceable
      ? (GetUnserviceableStatus.find(x => x.Value == record.unserviceable)?.Description ?? "UNKNOWN")
      : "NOT SHIPPED YET";
  };

  const getAlternatePnStatus = (record: any) => {
    return record.alternatePnStatus != null
      ? GetAlternatePnStatus.find(x => x.Value == record.alternatePnStatus)?.Description
      : "";
  };

  const Actions = props => {
    let record = props?.record;
    return (
      <Box style={{ flex: 1, flexDirection: "row" }}>
        <ButtonGroup variant="text" size="small">
          <DetailButtons {...props} resource={"pbhrequestorders"} />
          {user?.isCustomer === false && <RemarkButton {...props} />}
          {cancelButtonIsVisible(record) && (
            <CancelButton {...props} disabled={record?.requestStatus === PbhRequestStatus.Cancelled} />
          )}
        </ButtonGroup>
      </Box>
    );
  };
  const rowStyle = (record, index) => {
    if (record.requirementCategoryText === RequirementCategory.AOG) {
      return { color: "red" }; // Status 'x' ise kırmızı metin rengi
    }
    return { color: "black" }; // Diğer durumlarda siyah metin rengi
  };

  return (
    <Fragment>
      {isXSmall ? (
        <ListContextProvider value={{ ...listContext }}>
          <></>
        </ListContextProvider>
      ) : (
        <ListContextProvider value={{ ...listContext }}>
          <CopyableTableWrapper>
            <Datagrid rowStyle={rowStyle} classes={{ table: classes.datagrid }} hasBulkActions={false} optimized>
              <Actions label="Actions" />
              <RefNoField label="REF NO" />
              <TextField source="customerName" label="CUSTOMER" sortable={false} />
              <TextField source="customerPo" label="CUSTOMER PO" />
              <FunctionField
                sortable={false}
                label="REQUIREMENT CATEGORY"
                render={(record: any) => {
                  return <RequirementCategoryToolTip record={record} source={"requirementCategoryText"} />;
                }}
              />
              <FunctionField
                label="PN"
                render={record => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <TextField source="pn" label="PN" sortable={false} />
                      {((user?.isCustomer === false && record?.experienceIsShownTt === true) ||
                        (user?.isCustomer === true && record?.experienceIsShownCustomer === true)) && (
                        <Tooltip title={record?.experienceRemark}>
                          <IconButton>
                            <Info />
                          </IconButton>
                        </Tooltip>
                      )}
                      {record?.isPnRie === true && user?.isCustomer === false && (
                        <HtmlTooltip title="RIE">
                          <IconButton style={{ fontSize: "0.75rem" }}>
                            <Info />
                          </IconButton>
                        </HtmlTooltip>
                      )}
                    </div>
                  );
                }}
              />
              <TextField source="pnDescription" label="PN DESCRIPTION" sortable={false} />
              {user?.isCustomer == false && <BooleanField source="isPool" label="IS POOL SCOPE" />}
              <TextField source="airportCode" label="DESTINATION" />
              <TextField source="acRegistration" label="AC" />
              <CustomDateField source="createdDate" label="REQUEST DATE" showTime locales="en-GB" />
              <CustomDateField
                source="requestedDeliveryDate"
                label="REQUESTED DELIVERY DATE"
                showTime
                locales="en-GB"
              />
              <TextField source="requestStatusText" label="STATUS" sortable={false} />
              <FunctionField label="ALTERNATE PN STATUS" render={getAlternatePnStatus} />
              <FunctionField label="SERVICEABLE" render={getSvcStatus} />
              <FunctionField label="CORE UNIT" render={getUnsvcStatus} />
              {!user?.isCustomer && (
                <TextField source="currentPbhNote" label="PBH NOTE" aria-multiline sortable={false} />
              )}
            </Datagrid>
          </CopyableTableWrapper>
          <RequestRemark
            isMatchCreate={isMatchCreate}
            setIsMatchCreate={setIsMatchCreate}
            requestRemark={request}
            handleClose={refresh}
          />
        </ListContextProvider>
      )}
    </Fragment>
  );
};

const mapStateToProps = state => ({
  statusList: state.pbhDashboard.statusList,
});
const mapDispatchToProps = dispatch => ({
  setStatusList: data => dispatch({ type: PBH_DASHBOARD_MODEL_CHANGED, payload: { statusList: data } }),
});
export default connect(mapStateToProps, mapDispatchToProps)(PbhDashboardDataGrid);
